import React from 'react'

type LocalSoundCacheContextType = {
  loadSound: (src: string) => void
  status: Record<string, 'DONE' | 'FETCHING'>
  sounds: Record<string, HTMLAudioElement>
}

const LocalSoundCacheContext =
  React.createContext<LocalSoundCacheContextType>(null)

const status: LocalSoundCacheContextType['status'] = {}

const LocalSoundCacheProvider = ({ children }) => {
  const [sounds, setSounds] = React.useState<
    LocalSoundCacheContextType['sounds']
  >({})

  const loadSound: LocalSoundCacheContextType['loadSound'] = React.useCallback(
    src => {
      const handleLoad = () => {
        const sound = new Audio(src)

        const listener = () => {
          setSounds(old => ({ ...old, [src]: sound }))
          status[src] = 'DONE'
          sound.removeEventListener('canplaythrough', listener)
        }

        sound.addEventListener('canplaythrough', listener)
      }

      if (!(src in status)) {
        status[src] = 'FETCHING'
        handleLoad()
      }
    },
    []
  )

  return (
    <LocalSoundCacheContext.Provider value={{ loadSound, status, sounds }}>
      {children}
    </LocalSoundCacheContext.Provider>
  )
}

export default LocalSoundCacheProvider

export const useLocalSoundCache = () => React.useContext(LocalSoundCacheContext)
